module.exports = __webpack_public_path__ + "media/src/public/img/podpis-9fbf446d6cb9506f777268ba7755d688.png";